import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-lrs-upload-document',
  templateUrl: './lrs-upload-document.component.html',
  styleUrls: ['./lrs-upload-document.component.scss']
})
export class LrsUploadDocumentComponent implements OnInit {

  document: FormGroup;
  submited:boolean;
  UserID:any;
  AdhocServiceID:any
  isLoading: boolean = false;
  DocumentList: Array<any>;
  Docname: any;
  fileToUpload:any
  files: any[] = [];
  filelegth: any;
  constructor(public dialogRef: MatDialogRef<LrsUploadDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private generalService: GeneralService, private router: Router) {
        this.UserID = data.UserID,
        this.AdhocServiceID = data.AdhocServiceID
        this.Docname = data.Docname
        // console.log("UserID",this.UserID)
        console.log('AdhocServiceID',this.Docname)
     }

     ngOnInit() {
      this.document = new FormGroup({
        selectDocument: new FormControl(null, Validators.required),
        file: new FormControl(null,Validators.required),
        // UserID: new FormControl(this.UserID),
        FileName:new FormControl(''),
      })
      this.document.controls.selectDocument.setValue(this.Docname)
      this.document.controls.selectDocument.disable()
    }
  close(){
    this.dialogRef.close()
  }

  get f(){ return this.document.controls}
  onSubmit(){
    console.log("jjhvcjs",this.Documents())
    this.submited = true;
    this.isLoading = true;
    console.log("controe",this.document.controls)
    if(this.document.valid){
      this.generalService.LRSUploadDoc(this.Documents(),this.AdhocServiceID).subscribe((res:any)=>{
        Swal.fire({
          title:'Success',
          text:res.message,
          type:'success',
          timer:1500
        })
        this.isLoading= false;
        this.dialogRef.close(true)
      })
    }else{
      this.isLoading= false;
    }
  }
  onFileChange(e) {
    if (e == null || e.length === 0 || this.files.length === 0) {
      return;
    }
    // this.files = e;
    
    if (this.files.length > 1) {
      Swal.fire({
        title: 'Select only 1 file',
        text: 'You can only upload only one File',
        type: 'info',
        timer: 1500
      }).then(() => {
        this.files = [this.files[0]];
        console.log('push file',this.files[0])
        this.document.controls.uploadfile.setValue(this.files[0].name);
      });
    }
    if (this.files.length > 0) {
      const unsupportedFiles = [];
      const supportedFiles = [];
      for (let i = 0; i < this.files.length; i++) {
        const filetype = this.files[i].type;
        if (filetype.toLowerCase() !== 'application/pdf' && filetype.toLowerCase() !== 'pdf'
        ) {
          unsupportedFiles.push(this.files[i].name);
          console.log('unsupportedFiles',this.files[i].name)
        }
        else {
          supportedFiles.push(this.files[i])
          console.log('supportedFiles',this.files[i])
        }
      }
      if (unsupportedFiles.length > 0) {
        Swal.fire({
          title: 'Error',
          text: `${unsupportedFiles.join(', ')} File(s) Are Not Supported`,
          type: 'error',
          showConfirmButton: false,
          timer: 3000
        }).then(() => {
          this.files = supportedFiles;
          this.document.controls.uploadfile.setValue(this.files);
        });
      } else {
       
      }
    }
  }
  Documents(){
    const input = new FormData()
    for(var i=0; i<this.files.length; i++){
      input.append('file', this.files[i], this.files[i].name)
    }
    return input;
  }
}
